/**
 * Ruta pública `/contrasena/{token}` (T046): configura (SETUP) o restablece (RESET) la
 * contraseña. La misma pantalla atiende ambos propósitos; la API los distingue por el token.
 */
import { createFileRoute } from '@tanstack/react-router';

import { CompletePasswordPage } from '../features/auth/complete-password-page';

function CompletePasswordRoute() {
  const { token } = Route.useParams();
  return <CompletePasswordPage token={token} />;
}

export const Route = createFileRoute('/contrasena/$token')({
  component: CompletePasswordRoute,
});
